import { render, staticRenderFns } from "./ReceptionManagement.vue?vue&type=template&id=2710e10c&scoped=true"
import script from "./ReceptionManagement.vue?vue&type=script&lang=js"
export * from "./ReceptionManagement.vue?vue&type=script&lang=js"
import style0 from "./ReceptionManagement.vue?vue&type=style&index=0&id=2710e10c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2710e10c",
  null
  
)

export default component.exports